<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card  header-tag="header" footer-tag="footer">
                    <div slot="header">
                        <strong> Delivery Dashboard </strong> 
                    </div>
                    <b-row>
                        <b-col md="12">
                            <div>
                                <ul class="nav nav-tabs nav-justified">
                                    <li class="nav-item">
                                        <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Dispatch Date</a>
                                    </li>
                                    <li class="nav-item">
                                        <a @click="activeTab = 1"  class="nav-link " :class="{'active' : isActiveTab(1)}">Delivery Date</a>
                                    </li>
                                    <li class="nav-item">
                                        <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">Delivery Updated Date</a>
                                    </li>
                                </ul>
                            </div>
                        </b-col>

                        <b-col md="12">
                            <div class="tab-panel" v-if="isActiveTab(0)">
                                <Dispatch_date style="width:70%;"></Dispatch_date>
                            </div>
                            <div class="tab-panel" v-if="isActiveTab(1)">
                                <Delivery_date style="width:70%;"></Delivery_date>
                            </div>
                    
                            <div class="tab-panel" v-if="isActiveTab(2)">
                                  <Deliveryupdated_date style="width:70%;"></Deliveryupdated_date>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Dispatch_date from './Dispatch_date.vue'
import Delivery_date from './Delivery_date.vue'
import Deliveryupdated_date from './Deliveryupdated_date.vue'
export default {
    data() {
        return {
            activeTab: 0,
            Dispatch_date,
            Delivery_date,
            Deliveryupdated_date,
        }
    },
    components : {
        Dispatch_date,
        Delivery_date,
        Deliveryupdated_date,
    },

    created: function() {
        this.isActiveTab(0);
    },

    methods: {
        isActiveTab(id)
        {
        return this.activeTab === id
        }
    }
}
</script>